import { render, staticRenderFns } from "./searchSelectItems.vue?vue&type=template&id=5bb9f402&"
import script from "./searchSelectItems.vue?vue&type=script&lang=js&"
export * from "./searchSelectItems.vue?vue&type=script&lang=js&"
import style0 from "./searchSelectItems.vue?vue&type=style&index=0&id=5bb9f402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports